<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <v-form ref="form">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.model') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.model }}</p>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.id') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.id }}</p>
            </v-col>
            <v-col class="pt-0 pb-0" cols="6">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.appVersion') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.appVersion }}</p>
            </v-col>
            <v-col class="pt-0 pb-0" cols="6">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.certificate') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.certificate }}</p>
            </v-col>
            <v-col class="pt-0 pb-0" cols="6">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.productionDate') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.productionDate }}</p>
            </v-col>
            <v-col class="pt-0 pb-0" cols="6">
              <v-row align="center">
                <v-col class="font-weight-medium" cols="auto">{{ $t('formBike.maintenance') }}</v-col>
              </v-row>
              <p class="text-underline pb-3">{{ info.maintenance }}</p>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="7">
        <info-card class="mb-10" :info="info"></info-card>
        <div class="map-wrap">
          <google-map :zoom="range.zoom" :paths="range.paths" :riders="riders" :center="range.position"></google-map>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import InfoCard from '@/components/Bikes/InfoCard'

export default {
  components: { InfoCard, GoogleMap },
  data () {
    return {
      info: {
        model: 'SCP0305',
        id: 'acac0304',
        appVersion: 'E2342.34',
        certificate: '289348v382c32',
        productionDate: '2019/12/22',
        maintenance: '信義安和站',
        rental: 'RESERVED',
        status: 'NORMAL',
        battery: '88%',
        updateAt: '2020/02/20/13:00'
      },
      riders: [
        {
          id: 1,
          position: { lat: 25.021411, lng: 121.5434588 }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    })
  }
}
</script>

<style lang="stylus" scoped>
  .text-underline
    border-bottom 1px solid $primary
</style>
